<script setup lang="ts">
import MainForm from "@/pages/MainForm.vue"
</script>
<template>
  <div id="__next">
    <div class="overflow-x-hidden min-h-screen bg-opacity-30 bg-cover bg-center bg-no-repeat">
      <div class="relative h-screen w-screen">

        <div
          class="absolute inset-0 flex flex-col justify-center items-center w-5/6 max-w-lg xl:max-w-3xl mx-auto text-center">
          <div class="space-y-5 md:space-y-6 w-full">
            <h1 class="font-primary text-gray-100 text-2xl md:text-4xl md:leading-tight">
              {{ $t('text.url shortener by') }}
              <span class=" text-teal-400 font-bold">PALMCO</span>
            </h1>
            <p class="font-secondary text-palette-light text-base text-gray-100 md:text-lg lg:text-xl">
              {{ $t('text.fill out the form below according to your needs') }}
            </p>
            <MainForm />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>